export const canon = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 20,
  inputPaddingInline: 10,

  inputHeight: 50,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 16,
  inputFontFamily: '"Helvetica", sans-serif',
  inputColor: "#000000",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "transparent",
  inputBorderWidth: 1,
  inputBorderRadius: 3,

  inputHoverColor: "#000000",
  inputHoverBorderColor: "transparent",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 20,
  selectPaddingInline: 10,

  selectHeight: 50,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 16,
  selectFontFamily: '"Helvetica", sans-serif',
  selectColor: "#000000",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 400,

  selectBorderColor: "transparent",
  selectBorderWidth: 1,
  selectBorderRadius: 3,

  selectHoverColor: "#000000",
  selectHoverBorderColor: "transparent",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 20,
  textAreaPaddingInline: 10,

  textAreaHeight: 50,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 16,
  textAreaFontFamily: '"Helvetica", sans-serif',
  textAreaColor: "#000000",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "transparent",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 3,

  textAreaHoverColor: "#000000",
  textAreaHoverBorderColor: "transparent",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#000000",
  placeholderFontFamily: '"Helvetica", sans-serif',
  placeholderFontSize: 16,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#000000",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 5,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 16,
  fieldLabelColor: "#000000",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#CC0000",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Helvetica", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#000000",
  descriptionFontSize: 16,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Helvetica", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 15,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 3,
  checkboxUncheckedBorderColor: "#000000",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#CC0000",
  checkboxCheckedBorderColor: "#000000",
  checkboxCheckedColor: "#fff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Helvetica", sans-serif',
  checkboxLabelFontSize: 16,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#000000",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#000000",
  radioUncheckedBackgroundColor: "#fff",
  radioCheckedBackgroundColor: "#CC0000",
  radioCheckedBorderColor: "#000000",

  radioAlignment: "none",

  radioLabelFontFamily: '"Helvetica", sans-serif',
  radioLabelFontSize: 16,
  radioLabelFontWeight: 400,
  radioLabelColor: "#000000",

  // **********************************
  // submit button

  submitMarginTop: 50,
  submitFontSize: 25,
  submitFontFamily: "'Helvetica', sans-serif",
  submitWidth: 273,
  submitWidthUnits: "px",
  submitHeight: 75,
  submitBorderRadius: 3,
  submitBorderWidth: 2,
  submitBackground: "transparent",
  submitColor: "#000000",
  submitBorderColor: "#000000",
  submitBackgroundHover: "transparent",
  submitBorderColorHover: "#000000",
  submitColorHover: "#000",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "center",
};

  